import type { ModalProps } from '@viewup/ui';
import { ArrowRight, Button, Column, Icon, Modal, Typography } from '@viewup/ui';
import { Account } from 'app/viewing/_entities/common';
import { useGetNBlogAccounts } from 'app/viewing/_entities/post';

type ManageModalProps = Pick<ModalProps, 'exitHandler' | 'isOpen'>;

export const ManageModal = (props: ManageModalProps) => {
  const { data: accounts } = useGetNBlogAccounts();

  return (
    <Modal
      exitHandler={props.exitHandler}
      isOpen
      styledComponents={{
        root: {
          width: '80%',
        },
      }}
    >
      <Column>
        <Typography fontType='header3.bold' mb={8}>
          계정 관리
        </Typography>
        <Typography color='text.assistance' fontType='caption.regular' mb={8}>
          {`클릭뷰업은 하나의 계정으로 진행돼요.\n적립할 계정을 클릭해 주세요!`}
        </Typography>

        <Button
          onClick={() => {
            window.open(
              'https://smiledragon.notion.site/1f2d07302a228106b103f130eb74e72c',
              '_blank',
            );
          }}
          rightContent={<Icon source={ArrowRight} />}
          size='S'
          variant='secondarySolid.info'
        >
          어떤 계정을 선택해야 할까요?
        </Button>

        <Column gap={8} py={24}>
          {accounts?.map((account) => (
            <Account account={account} key={account.accountName}>
              {(account?.needSubmission || 0) > 0 && (
                <Button
                  css={{ marginTop: 8, pointerEvents: 'none', width: '100%' }}
                  size={'S'}
                  variant='secondarySolid.info'
                >
                  해당 계정에 제출이 필요해요!
                </Button>
              )}
            </Account>
          ))}
        </Column>
      </Column>
    </Modal>
  );
};
